import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import Send from 'assets/icons/Send';
import { useTranslation } from 'react-i18next';

const ChatSendMessage = ({
  className,
  handleSendMessage,
  loading,
  isStarted,
  isSending
}) => {
  const [message, setMessage] = useState('');
  const isInactive = !isStarted || loading || isSending;
  const { t } = useTranslation('Chat');

  const handleClickSend = useCallback(() => {
    if (isInactive) return;

    handleSendMessage(message);
    setMessage('');
  }, [message, handleSendMessage, isInactive]);

  const handleEnterKey = useCallback(
    e => {
      if (e.key === 'Enter' && e.shiftKey === false) {
        e.preventDefault();
        handleClickSend();
      }
    },
    [handleClickSend]
  );

  const handleTextChange = useCallback(event => {
    if (!event.target) return;

    setMessage(event.target.value);
  }, []);

  return (
    <div className={className} data-testid="chat-send-message">
      <div className="chat-send-message">
        <TextareaAutosize
          className="chat-send-message__textarea"
          data-testid="chat-send-message__textarea"
          placeholder={t('yourMessage')}
          rows={2}
          value={message}
          onChange={handleTextChange}
          onKeyDown={handleEnterKey}
          disabled={!isStarted}
        />
        <button
          data-testid="sendmessage-button"
          className={`chat-send-message__button ${
            isInactive ? 'chat-send-message__button--inactive' : ''
          }`}
          onClick={handleClickSend}
          disabled={isInactive}
        >
          <Send />
        </button>
      </div>
    </div>
  );
};
ChatSendMessage.propTypes = {
  className: PropTypes.string
};
export default ChatSendMessage;
